import store from "../../index.js";
import CouponTicketConstant from "@/mixins/coupon/const/couponTicketConstant.js";
import CouponTicketAcConstant from "@/mixins/coupon/const/couponTicketAcConstant.js";

import { callGetApi, callPostApi, callPatchApi, callDeleteApi } from "@/utils/apiWrapper";
import couponTicketConstant, {
  initialManualCouponInfoState,
  initialCouponInfoState,
} from "@/mixins/coupon/const/couponTicketConstant.js";

export const modules = {
  store,
};

export const state = {
  _couponInfo: {
    price: 0,
    eventName: null,
    applyType: null,
  },
  _manualCouponInfo: { ...initialManualCouponInfoState },
  _error: {
    code: 0,
    message: "",
  },
};

export const mutations = {
  [CouponTicketConstant.SET_EVENT_COUPON_NAME](state, item) {
    state._couponInfo.price = item.price;
    state._couponInfo.eventName = item.eventName;
    state._couponInfo.applyType = item.applyType;
  },
  [CouponTicketConstant.SET_EVENT_COUPON_RESET](state) {
    state._couponInfo = { ...initialCouponInfoState };
  },
  [CouponTicketConstant.SET_MANUAL_COUPON_INFO](state, item) {
    state._manualCouponInfo = item;
  },
  [CouponTicketConstant.SET_MANUAL_COUPON_INFO_DEFAULT](state) {
    state._manualCouponInfo = { ...initialManualCouponInfoState };
  },
  [CouponTicketConstant.SET_COUPON_ERROR](state, item) {
    state._error = item;
  },
};

export const actions = {
  async acCouponAvailable({ commit }) {
    return await callGetApi({
      url: CouponTicketAcConstant.GET_ORDER_COUPON_AVAILABLE,
      data: {},
      commit,
      errorMutation: CouponTicketConstant.SET_COUPON_ERROR,
    });
  },

  async acCouponManualValidate({ commit }, { service_type, code_token, origin_price, birth_date }) {
    const res = await callPostApi({
      url: CouponTicketAcConstant.GET_ORDER_COUPON_MANUAL_VALIDATE,
      data: { service_type, code_token, origin_price, birth_date },
      commit,
      errorMutation: CouponTicketConstant.SET_COUPON_ERROR,
    });

    if (!res) return false;
    commit(CouponTicketConstant.SET_MANUAL_COUPON_INFO, res);
    return res;
  },

  async acCheckManualCouponUsed({ commit }, { code_token }) {
    const res = await callGetApi({
      url: CouponTicketAcConstant.GET_ORDER_COUPON_MANUAL_USED,
      params: { code_token },
      commit,
      errorMutation: CouponTicketConstant.SET_COUPON_ERROR,
    });
    return res;
  },

  async acCouponIncheonAvailable({ commit }, { contractType } = {}) {
    const params = {};
    if (contractType) {
      params.contract_type = contractType;
    }
    const res = await callGetApi({
      url: CouponTicketAcConstant.GET_ORDER_COUPON_INCHEON_AVAILABLE,
      params,
      commit,
      errorMutation: CouponTicketConstant.SET_COUPON_ERROR,
    });
    return res;
  },
};

export const getters = {
  geCodeFail: state => {
    switch (state._error.code) {
      case 0:
        return "";
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
